module.exports = __webpack_public_path__ + "static/media/backgroundSFX.972d864e.mp3";